<template>
    <div>
        <b-form-checkbox-group>
            <div class="custom-control custom-radio" v-for="item in constraints.selectables.items" v-bind:key="item">
                <input 
                    type="radio" 
                    class="custom-control-input" 
                    :id="field.key + '_' + item" 
                    :value="item"
                    :name="field.key"
                    v-model="content" 
                    />
                <label class="custom-control-label" :for="field.key + '_' + item"> {{ item }} </label>
            </div>
        </b-form-checkbox-group>
         <b-form-invalid-feedback :id="field.key" v-for="e in errors" :key="e" style="display:block">
          {{ e }}
        </b-form-invalid-feedback>
    </div>
</template>

<script>
export default {
    name: "IdentityFieldRadio_Text",
    props: {
        field: {
            type: Object
        },
        value: {
            type: Array | String
        },
        translator: {
            type: Function
        }
    },
    data: function() {
        return {
            errors: []
        }
    },
    watch: {
        content(val) {
            this.check(val)
        }
    },
    computed: {
        content: {
            get() {
                if (this.value == "") {
                    return []
                }
                
                return this.value;
            },

            set(val) {
                this.check(val)
                this.$emit('input', val);
            }
        },
        constraints() {
            let constr = this.field.constraints

            return constr
        }
    },
    methods: {
        check(val) {
            this.errors = []
            
            if (!this.constraints.required) return this.$emit('input', val);

            if (val == "") {
                this.errors.push(this.translator("identityField.requiredField"))
            }
            
            this.$emit("error", {field: this.field.key, error: this.errors.length > 0})
        }
    },
    mounted() {
        this.check(this.content)
    }
}
</script>